import get from 'lodash/get';
import type { Doc as YDoc } from 'yjs';

import { useObservedProperty } from './yjs.client';
import { getContentObjectsMap, validateYMap } from '../common/utils/yjs';

export function useWidgetStyle<T = string>(document: YDoc, widgetId: string, property: string) {
  const contentObjectMap = getContentObjectsMap(document);
  const widgetStyleMap = validateYMap(validateYMap(contentObjectMap.get(widgetId)).get('style'));
  return useObservedProperty<T | undefined>(widgetStyleMap, property);
}

export function useStaticWidgetStyle<T = string>(
  document: Record<string, unknown>,
  widgetId: string,
  property: string
): T | undefined {
  return get(document, `staticContent.contentObjects.${widgetId}.style.${property}`) as T | undefined;
}
